const Marionette = require('backbone.marionette');
const templates = require('../templates');
const app = require('../app.js');

module.exports = Marionette.ItemView.extend({
  template: templates.main_booking_tooltip,
  serializeModel() {
    return {
      booking: this.model,
      activityTextColor: this.getColorByBgColor(this.model.get('activity').get('color'))
    };
  },
  events: {
    'click .popup_activity_close': 'closeActivityPopup'
  },
  closeActivityPopup() {
    app.vent.trigger('closeActivityPopup');
  },
  getColorByBgColor(bgColor) {
    if (!bgColor) {
      return '';
    }

    const colors = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(bgColor);
    const red = parseInt(colors[1], 16);
    const green = parseInt(colors[2], 16);
    const blue = parseInt(colors[3], 16);

    if (red * 0.299 + green * 0.587 + blue * 0.114 > 186) {
      return '#000000';
    }

    return '#ffffff';
  }
});



// WEBPACK FOOTER //
// ./src/views/main_booking_tooltip.js